/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import VPagination from "@hennge/vue3-pagination";
import moment from "moment";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import CraAddEditModal from "../CraManagement/CraAddEditModal.vue";

export default {
    name: "CraList",
    components: {
        VPagination,
        CraAddEditModal
    },
    data() {
        return {
            searchField: {

            },
            baseurl: process.env.VUE_APP_Service_URL,
            currentPage: 1,
            totalPage: 1,
            pageindex: 1,
            pagesize: 10,
            SortProperty: "createdAt",
            SortOrder: 1,
            SortOrderInt: 0,
            isAscending: true,
            craList: [],
            totalCount: 0,
            showTableLoading: false,
            idToken: "",
            showFilter: false,
            selectedcolumnobj: {},
            roleprivileges: "",
            CountryStatus: [],
            dropdownOpen: false,
            showCreateCraModal: false,
            editingCraId: null,
            fullCraList: [],
            searchField: {
                cra: "",
                siteCode: ""
            },
            showViewSitesModal: false,
            selectedCraForView: null,
        }
    },
    watch: {
        returnList: {
            handler() {
                this.initializeColumns();
            },
            immediate: true,
            deep: true,
        },
    },
    computed: {
        paginatedCraList() {
            const start = (this.currentPage - 1) * this.pagesize;
            const end = start + this.pagesize;
            return this.fullCraList.slice(start, end);
        }
    },

    async mounted() {
        window.addEventListener("studyIdChanged", (event) => {
            console.log("StudyIDChanged into" + event.detail.storage);
            this.idToken = store.getters.getIdToken;
            this.listCras();
        });
        await this.listCras();
    },

    methods: {
        async setroleprivileges() {
            this.roleprivileges = await store.getters.getRolesprivilegeData;
        },
        initializeColumns() {
            if (this.craList.length > 0) {
                const allowedKeys = [
                    "CRA Name",
                    "Site Code",
                    "Planned Date",
                ];

                const fieldLabels = {
                    craName: "CRA Name",
                    siteCode: "Site Code",
                    plannedDate: "Planned Date",
                    active: "Active",
                };

                const readableData = allowedKeys.map((key) => fieldLabels[key] || key);
                this.getColumns = readableData;

                this.selectedColumns = [...this.getColumns];

                this.selectedcolumnobj = this.selectedColumns.reduce((obj, key) => {
                    obj[key] = true;
                    return obj;
                }, {});
            }
        },

        async listCras() {
            try {
                this.showTableLoading = true;

                const currentstudy = store.getters.getStudyIs;
                this.idToken = store.getters.getIdToken;

                const response = await axios.get(
                    `${this.baseurl}/forms/cra/craassignlist`,
                    {
                        params: {
                            StudyId: currentstudy,
                            pageNumber: this.currentPage,
                            pageSize: this.pagesize,
                            SortProperty: this.SortProperty,
                            SortOrder: this.SortOrderInt,
                            CRAId: this.searchField.cra || null,
                            SiteCode: this.searchField.siteCode || null
                        },
                        headers: {
                            Authorization: "Bearer " + this.idToken,
                            "Content-Type": "application/json"
                        }
                    }
                );

                const apiData = response.data?.results || [];

                this.fullCraList = apiData.map(item => {
                    const sites = [];

                    item.studies?.forEach(study => {
                        study.sites?.forEach(site => {
                            sites.push({
                                siteCode: site.siteCode || "-",
                                siteName: site.siteName || "-",
                                plannedDate: site.plannedDate
                            });
                        });
                    });

                    return {
                        id: item.id,
                        craId: item.craId,
                        craName: item.craId,
                        sites: sites
                    };
                });


                this.totalCount = response.data.totalCount;
                this.totalPage = Math.ceil(this.totalCount / this.pagesize);

            } catch (error) {
                console.error("Error fetching CRAs:", error);
                this.fullCraList = [];
                this.totalCount = 0;
                this.totalPage = 0;
            } finally {
                this.showTableLoading = false;
            }
        },

        EditCRA(Id, studyId) {
            this.editingCraId = Id;
            console.log("Editing CRA with ID:", Id);
            this.showCreateCraModal = true;
        },

        loadPage(page) {
            this.currentPage = page;
            this.listCras();
        },

        formatDateDDMMYYYY(date) {
            if (!date) return "";
            const d = new Date(date);
            const day = String(d.getUTCDate()).padStart(2, "0");
            const month = String(d.getUTCMonth() + 1).padStart(2, "0");
            const year = d.getUTCFullYear();
            return `${day}-${month}-${year}`;
        },

        SortSelected(sortProp) {
            if (this.SortProperty === sortProp) {
                this.isAscending = !this.isAscending;
            } else {
                this.SortProperty = sortProp;
                this.isAscending = true;
            }
            this.SortOrderInt = this.isAscending ? 0 : 1;
            this.pageindex = 1;
            this.currentPage = 1;
            this.listCras();
        },


        closeCraModal() {
            this.showCreateCraModal = false;
            this.editingCraId = null;
        },
        CreateCra() {
            this.editingCraId = null;
            this.showCreateCraModal = true;
        },


        async refreshCraList() {
            await this.listCras();
        },
        async DeleteCra(craId) {
            if (confirm("Are you sure you want to delete this CRA?")) {
                try {
                    const response = await axios.delete(`${this.baseurl}/forms/cra/deletecramapping?id=${craId}`, {
                        headers: {
                            Authorization: "Bearer " + this.idToken,
                            "Content-Type": "application/json"
                        }
                    });
                    alert("CRA deleted successfully.");
                    this.refreshCraList();
                } catch (error) {
                    console.error("Error deleting CRA:", error);
                    alert("Failed to delete CRA.");
                }
            }
        },
        search() {
            this.pageindex = 1;
            this.currentPage = 1;
            this.listCras();
        },

        openViewSitesModal(craItem) {
            this.selectedCraForView = craItem;
            this.showViewSitesModal = true;
        },

        closeViewSitesModal() {
            this.showViewSitesModal = false;
            this.selectedCraForView = null;
        }
    }
};